import { ConfirmDialogContext } from "providers/ConfirmDialogProvider";
import { ReactNode, useContext } from "react";

import {
  buttonAnnul,
  buttonConfirm,
  buttonDelete,
  buttonExitWithoutSave,
  buttonLogout,
  modalConfirmDeleteData,
  modalConfirmLogoutSubtitle,
  modalConfirmLogoutTitle,
  modalConfirmUpdatesNotSaved,
  modalConfirmUpdatStatusReportSubtitle,
  modalConfirmUpdatStatusReportTitle,
} from "_constants";
import { PrimeIcons } from "primereact/api";
import { logout } from "services/AuthenticationService";
import { deleteTokensFromStorage } from "utils";
import { useNavigate } from "react-router-dom";

export const useConfirmDialogExit = () => {
  const { showDialog, hideDialog } = useContext(ConfirmDialogContext);
  const navigate = useNavigate();

  const showConfirmDialogExit = ({
    rejectCallback,
  }: {
    acceptCallback?: Function;
    rejectCallback?: Function;
  }) => {
    showDialog({
      dismissableMask: true,
      message: null,
      body: (
        <div>
          <h4>{modalConfirmLogoutTitle}</h4>
          <span className="text-base-regular">
            {modalConfirmUpdatesNotSaved}
          </span>
        </div>
      ),
      acceptClassName: "p-button-text p-button-secondary",
      rejectClassName: "p-button-warning",
      modalClass: "custom-confirm-dialog",
      icon: (
        <span
          className={`${PrimeIcons.SIGN_OUT} confirm-dialog-icon warning padd-14 margin-top-14`}
        />
      ),
      rejectLabel: buttonExitWithoutSave,
      acceptLabel: buttonAnnul,
      accept: () => {
        hideDialog({ message: null, dismissableMask: true });
      },
      reject: rejectCallback,
    });
  };

  const showConfirmDialogDelete = ({
    title,
    subtitle,
    rejectCallback,
    rejectButtonLabel,
    icon,
    body,
  }: {
    title?: string;
    subtitle?: string;
    rejectCallback?: Function;
    rejectButtonLabel?: string;
    icon?: string;
    body?: ReactNode;
  }) => {
    showDialog({
      dismissableMask: true,
      message: null,
      body: (
        <div>
          <h4>{title ?? modalConfirmDeleteData}</h4>
          {subtitle && (
            <span
              className="text-base-regular break-all d-block line-h w-break"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            ></span>
          )}
          {body}
        </div>
      ),
      acceptClassName: "p-button-text p-button-secondary",
      rejectClassName: "p-button-danger",
      modalClass: "custom-confirm-dialog custom-confirm-dialog-delete-account",
      icon: (
        <span
          className={`${
            icon ?? PrimeIcons.TRASH
          } confirm-dialog-icon danger padd-14`}
        />
      ),
      rejectLabel: rejectButtonLabel ?? buttonDelete,
      acceptLabel: buttonAnnul,
      accept: () => {
        hideDialog({ message: null, dismissableMask: true });
      },
      reject: rejectCallback,
    });
  };

  const showLogoutConfirmDialogExit = () => {
    showDialog({
      dismissableMask: true,
      message: null,
      body: (
        <div>
          <h4>{modalConfirmLogoutTitle}</h4>
          <span className="text-base-regular">
            {modalConfirmLogoutSubtitle}
          </span>
        </div>
      ),
      acceptClassName: "p-button-text p-button-secondary",
      rejectClassName: "p-button-warning",
      modalClass: "custom-confirm-dialog",
      icon: (
        <span
          className={`${PrimeIcons.SIGN_OUT} confirm-dialog-icon warning padd-14 margin-top-14`}
        />
      ),
      rejectLabel: buttonLogout,
      acceptLabel: buttonAnnul,

      accept: () => {
        hideDialog({ message: null, dismissableMask: true });
      },
      reject: () => {
        logout()
          .then((_) => {
            deleteTokensFromStorage();
            navigate("/");
          })
          .catch((_) => {});
      },
    });
  };

  const showConfirmUpdateStatusReport = ({
    callback,
  }: {
    callback: Function;
  }) => {
    showDialog({
      dismissableMask: true,
      message: null,
      body: (
        <div>
          <h4>{modalConfirmUpdatStatusReportTitle}</h4>
          <span className="text-base-regular">
            {modalConfirmUpdatStatusReportSubtitle}
          </span>
        </div>
      ),

      rejectClassName: "p-button-text p-button-secondary",
      modalClass: "custom-confirm-dialog",
      icon: (
        <span
          className={`${PrimeIcons.INFO_CIRCLE} confirm-dialog-icon primary padd-14 margin-top-14`}
        />
      ),
      rejectLabel: buttonAnnul,
      acceptLabel: buttonConfirm,

      accept: () => {
        callback();
      },
      reject: () => {
        hideDialog({ message: null, dismissableMask: true });
      },
    });
  };

  return {
    showConfirmDialogExit,
    showLogoutConfirmDialogExit,
    showConfirmDialogDelete,
    showConfirmUpdateStatusReport,
  };
};
